import { CRANK, FROG_X, GROUND, HUB_Y, POSTS, ROPE_R } from '../sim/constants';
import { TAU, ell, fillStroke } from './common';

export interface RopeState {
  z: number; // -1 behind the frog .. 1 in front
  endY: number;
  midY: number;
  shift: number; // x offset of the ends (second rope sits on the inner side)
}

/** Rope position from the simulation phase. Each whole turn is a pass under the frog. */
export function ropeAt(phase: number, dir: 1 | -1, second: boolean): RopeState {
  const a = TAU * (second ? phase - 0.5 : phase);
  const c = Math.cos(a);
  const z = (second ? Math.sin(a) : -Math.sin(a)) * dir;
  return { z, endY: HUB_Y + CRANK * c, midY: HUB_Y + ROPE_R * c, shift: second ? 8 : 0 };
}

export function ropeStroke(ctx: CanvasRenderingContext2D, color: string, back: string, z: number, hc: boolean): void {
  ctx.lineCap = 'round';
  if (hc) {
    ctx.strokeStyle = '#111111';
    ctx.lineWidth = 9 + z * 1.6;
    ctx.stroke();
    ctx.strokeStyle = z >= 0 ? '#FFFFFF' : '#FFE14D';
    ctx.lineWidth = 5 + z * 1.6;
    ctx.stroke();
    return;
  }
  ctx.strokeStyle = z >= 0 ? color : back;
  ctx.lineWidth = 5 + z * 1.6;
  ctx.stroke();
  ctx.strokeStyle = `rgba(255,255,255,${0.25 + 0.15 * z})`;
  ctx.lineWidth = 1.5;
  ctx.stroke();
}

export function drawRope(ctx: CanvasRenderingContext2D, r: RopeState, color: string, back: string, hc: boolean): void {
  const x0 = POSTS[0] + r.shift;
  const x1 = POSTS[1] - r.shift;
  const cx = 2 * FROG_X - (x0 + x1) / 2;
  const cy = 2 * r.midY - r.endY;
  ctx.beginPath();
  ctx.moveTo(x0, r.endY);
  ctx.quadraticCurveTo(cx, cy, x1, r.endY);
  ropeStroke(ctx, color, back, r.z, hc);
}

export function drawCranks(ctx: CanvasRenderingContext2D, ropes: RopeState[], handle: string): void {
  for (const r of ropes) {
    for (const px of POSTS) {
      const x = px === POSTS[0] ? px + r.shift : px - r.shift;
      ctx.strokeStyle = '#3B2A1E';
      ctx.lineWidth = 5;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(x, HUB_Y);
      ctx.lineTo(x, r.endY);
      ctx.stroke();
      ell(ctx, x, HUB_Y, 6, 6);
      fillStroke(ctx, '#D9B25A', '#3B2A1E', 2);
      ell(ctx, x, r.endY, 4.5, 4.5);
      fillStroke(ctx, handle, '#3B2A1E', 2);
    }
  }
}

/** The rope after it caught the frog: pulled from both posts to its feet. */
export function drawTangledRope(ctx: CanvasRenderingContext2D, color: string, back: string, hc: boolean, frogX = FROG_X): void {
  const endY = HUB_Y + CRANK;
  ctx.beginPath();
  ctx.moveTo(POSTS[0], endY);
  ctx.quadraticCurveTo(250, GROUND + 6, frogX - 30, GROUND - 24);
  ropeStroke(ctx, color, back, 0.4, hc);
  ctx.beginPath();
  ctx.moveTo(POSTS[1], endY);
  ctx.quadraticCurveTo(550, GROUND + 6, frogX + 30, GROUND - 30);
  ropeStroke(ctx, color, back, 0.4, hc);
}
